import { kunciShopee } from './shopeeImport';

/**
 * Salin medan sebuah produk library (My Products / System) ke dalam kad KOSONG
 * yang SUDAH wujud — bila pengguna tekan "Add product" pada petak gambar kad.
 *
 * ⚠️ KEMBAR (logik sama wujud di dua tempat):
 *    Senarai medan di sini WAJIB selaras dengan `onCiptaKadKosong` dalam
 *    `src/App.jsx`. Di sana produk staged disalin ke kad BAHARU; di sini
 *    produk pilihan disalin ke kad yang sudah ada. Tambah/ubah satu medan →
 *    kemas kini KEDUA-DUA tempat, jika tidak medan baharu tidak akan sampai.
 *
 * Penanda kad (`kosong: true`, `moduleId: 'blank'`) SENGAJA TIDAK disentuh:
 *    kad kekal "blank card" (bebas pindah antara tab + badge "Blank card"),
 *    cuma data produk + gambar yang masuk. Pengguna masih boleh tukar fikiran
 *    dan ganti/buang produk kemudian.
 *
 * Nama kad hanya diganti jika ia masih nama lalai "Blank card" — supaya nama
 * yang pengguna taip sendiri tidak ditindih (keputusan user 2026-11-04).
 *
 * @param {object} lp       Produk dari library.
 * @param {string} namaKini Nama kad semasa (untuk jaga rename pengguna).
 * @returns {object|null}   Medan untuk updateProduct(), atau null jika lp buruk.
 */
export function salinProdukKeKad(lp, namaKini) {
    if (!lp || typeof lp !== 'object') return null;      // nilai buruk → gagal jelas, jangan tulis
    const namaLalai = !namaKini || namaKini === 'Blank card';
    return {
        name: namaLalai ? (lp.name || 'Blank card') : namaKini,
        link: lp.link || '',
        shopeeLink: lp.shopeeLink || '',
        shopeeProductUrl: kunciShopee(lp.shopeeProductUrl) ? String(lp.shopeeProductUrl).trim() : '',
        price: lp.price || '',
        originalPrice: lp.originalPrice || '',
        discount: lp.discount || '',
        imageBase64: lp.imageBase64 || null,
        imageUrl: lp.imageUrl || null,
        localImagePath: null,
        extraImageUrls: Array.isArray(lp.extraImageUrls)
            ? lp.extraImageUrls.filter(u => typeof u === 'string' && u).slice(0, 4)
            : [],
    };
}
